// assets/edm-dots.js — mobile Dots, robust synchronisiert (Dawn)
(() => {
  const mql = window.matchMedia('(min-width: 750px)');

  function getList(viewer) {
    // Liste der Slides (robuste Auswahl)
    return (
      viewer.querySelector('[id^="Slider-Gallery-"]') ||
      viewer.querySelector('.product__media-list') ||
      viewer.querySelector('.slider')
    );
  }

  function getSlides(list) {
    return Array.from(list.querySelectorAll('.slider__slide'));
  }

  function getActiveIndexByScroll(list, slides) {
    // Fallback: Slide mit Center am nächsten zu List-Mitte
    const mid = list.scrollLeft + list.clientWidth / 2;
    let best = 0, bestD = Infinity;
    slides.forEach((s, i) => {
      const c = s.offsetLeft + s.clientWidth / 2;
      const d = Math.abs(c - mid);
      if (d < bestD) { bestD = d; best = i; }
    });
    return best;
  }

  function buildDots(viewer) {
    const list = getList(viewer);
    if (!list) return;
    let slides = getSlides(list);
    if (slides.length <= 1) return;

    // evtl. alte Dots (direkte Geschwister) entfernen
    const existing = viewer.parentElement.querySelectorAll('.edm-dots');
    existing.forEach(n => n.remove());

    const dotsWrap = document.createElement('div');
    dotsWrap.className = 'edm-dots edm-dots--below';
    dotsWrap.setAttribute('role', 'tablist');
    dotsWrap.setAttribute('aria-label', 'Bilder');
    viewer.insertAdjacentElement('afterend', dotsWrap);

    const dots = slides.map((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'edm-dot';
      b.setAttribute('aria-label', `Bild ${i + 1} von ${slides.length}`);
      b.addEventListener('click', () => {
        list.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        setActive(i);
      }, { passive: true });
      dotsWrap.appendChild(b);
      return b;
    });

    const setActive = (i) => {
      dots.forEach((d, idx) => d.setAttribute('aria-current', idx === i ? 'true' : 'false'));
    };

    // initial
    const initialFromClass = list.querySelector('.slider__slide.is-active');
    let current = initialFromClass ? slides.indexOf(initialFromClass) : getActiveIndexByScroll(list, slides);
    if (current < 0) current = 0;
    setActive(current);

    // Scroll-Sync
    let raf = 0;
    list.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const idx = getActiveIndexByScroll(list, slides);
        if (idx !== current) { current = idx; setActive(current); }
      });
    }, { passive: true });

    // Dawn-Event: slideChanged
    viewer.addEventListener('slideChanged', (e) => {
      const el = e?.detail?.currentElement;
      if (!el) return;
      const idx = slides.indexOf(el);
      if (idx >= 0 && idx !== current) { current = idx; setActive(current); }
    });

    // Klassenwechsel der Slides (Dawn setzt/entfernt .is-active)
    const mo = new MutationObserver(() => {
      const el = list.querySelector('.slider__slide.is-active');
      if (!el) return;
      const idx = slides.indexOf(el);
      if (idx >= 0 && idx !== current) { current = idx; setActive(current); }
    });
    mo.observe(list, { subtree: true, attributes: true, attributeFilter: ['class'] });

    // Wenn sich die Slides-Liste ändert (z. B. Lazy/Variant), neu aufbauen
    const moChildren = new MutationObserver(() => {
      const latest = getSlides(list);
      if (latest.length !== slides.length) {
        mo.disconnect(); moChildren.disconnect();
        buildDots(viewer); // Rebuild
      }
    });
    moChildren.observe(list, { childList: true });
  }

  function destroyDots(viewer) {
    viewer.parentElement.querySelectorAll('.edm-dots').forEach(n => n.remove());
  }

  function initAll() {
    document.querySelectorAll('slider-component[id^="GalleryViewer-"]').forEach((viewer) => {
      if (mql.matches) {
        // Desktop: Dots entfernen
        destroyDots(viewer);
      } else {
        buildDots(viewer);
      }
    });
  }

  // initial + bei Breakpointwechsel
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  mql.addEventListener('change', initAll);

  // Falls Sektionen live neugeladen werden (Theme Editor)
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', initAll);
})();
